import React from "react";
import { Link } from "react-router-dom";

function SmartManufacturing() {
  return (
    <div>
      <div class="wrapper2">
        <h2 class="heading2">Smart Manufacturing</h2>
      </div>
      <section class="py-0">
        <div class="container p-3">
          {/* <!-- more blogs --> */}
          <div class="row g-3">
            <div class="col-lg-4 col-12">

              <div class="product-item col">
                <div class="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/sm.png" alt="" class="card-img-top" />
                </div>
              </div>


              <p class="card-text text-muted py-1 px-1">
                Our IoT-powered systems revolutionize manufacturing with
                real-time monitoring and management. With tools like ConTrak, we
                ensure enhanced reporting, seamless cold chain management, and
                impeccable product integrity throughout the process.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div class="bg-light">
        <div class="container p-3">
          <h6 class="card-title fw-bold my-2">
            Our Connectivity Technologies{" "}
          </h6>
          <br />

          {/* <!--  <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="m-0">Popular Products</h6>
                  <a href="#">View all<i class="icofont-rounded-right"></i></a>
               </div>--> */}
          <div class="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-2 g-3">

            <div class="product-item col">
              <div
                class="card h-100 rounded-4 overflow-hidden osahan-card-list"
                style={{ border: "0px" }}
              >
                <img src="img/s2-min.png" alt="" class="card-img-top" />
                <h6
                  class="fw-normal"
                  style={{
                    fontSize: "13px",
                    textAlign: "center",
                    paddingTop: "10px",
                    color: "black",
                  }}
                >
                  <b>ConTrak</b>{" "}
                </h6>
                <p style={{ color: "black" }}>
                  IoT-Based Cold Chain Monitoring{" "}
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/certified-for-excellence"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/distribution"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>
      {/* <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Manufacturing Insights</h6>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <a href="/technology-at-work">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m5-min.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      <br />
                      Technology At Work
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/stringent-quality-testing">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m2-min.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "14px" }}>
                      <br />
                      Stringent Quality Testing
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/certified-for-excellence">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m3-min.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      <br />
                      Certified for Excellence
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/smart-manufacturing">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m4-min.png" alt="" className="card-img-top" />
                  <div
                    className="position-absolute text-overlay-f text-white p-3"
                    style={{ top: "30%" }}
                  >
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      <br />
                      <br />
                      Smart Manufacturing
                    </h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> */}
      {/* <Index /> */}
    </div>
  );
}

export default SmartManufacturing;
